import React, { useEffect, useState } from 'react'
// import Button from "../button";
import styles from './embassies_modal.module.css'
import { student } from '../../store/student'
import { report } from '../../store/report'
import http from '../../Service/http'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import dayjs from 'dayjs'

const EmbassiesModal = ({ openForm, openSpravka }) => {
	const [modalData, setModalData] = useState([])
	const [isSave, setIsSave] = useState(false)
	const [refusal, setRefusal] = useState(false)
	const [updateNaz, setUpdateNaz] = useState({
		naznachenie: '',
		surname: '',
		practice: false
	})
	const [reasonRefusal, setReasonRefusal] = useState({
		rejected_komment: ''
	})

	const year_c = new Date().getFullYear() - 1
	const year_po = new Date().getFullYear() - 1

	const day_c_os = '01'
	const month_c_os = '09'
	const year_c_os = new Date().getFullYear() - 1

	const day_po_os = '31'
	const month_po_os = '12'
	const year_po_os = new Date().getFullYear() - 1

	const day_c_vs = '01'
	const month_c_vs = '01'
	const year_c_vs = new Date().getFullYear()

	const day_po_vs = '31'
	const month_po_vs = '05'
	const year_po_vs = new Date().getFullYear()

	const day_c_practice = '01'
	const month_c_practice = '06'
	const year_c_practice = new Date().getFullYear()

	const day_po_practice = '01'
	const month_po_practice = '06'
	const year_po_practice = new Date().getFullYear()

	const day_c_holidays = '01'
	const month_c_holidays = '06'
	const year_c_holidays = new Date().getFullYear()

	const day_po_holidays = '31'
	const month_po_holidays = '08'
	const year_po_holidays = new Date().getFullYear()

	const [updateData, setUpdateData] = useState({
		data_c: `${year_c}`,
		data_po: `${year_po}`,
		data_c_os: `${year_c_os}-${month_c_os}-${day_c_os}`,
		data_po_os: `${year_po_os}-${month_po_os}-${day_po_os}`,
		data_c_vs: `${year_c_vs}-${month_c_vs}-${day_c_vs}`,
		data_po_vs: `${year_po_vs}-${month_po_vs}-${day_po_vs}`,
		data_c_practice: `${year_c_practice}-${month_c_practice}-${day_c_practice}`,
		data_po_practice: `${year_c_holidays}-${month_po_practice}-${day_po_practice}`,
		data_c_holidays: `${year_po_practice}-${month_c_holidays}-${day_c_holidays}`,
		data_po_holidays: `${year_po_holidays}-${month_po_holidays}-${day_po_holidays}`
	})

	// console.log("updateData.data_c",updateData.data_c)
	// console.log("updateData.data_po",updateData.data_po)
	// console.log("updateData.data_c_os",updateData.data_c_os)

	const { t, i18n } = useTranslation()

	const change = e => {
		const { name, value } = e.target
		setUpdateNaz({ ...updateNaz, [name]: value })
		console.log(':nameval', { [name]: value })
		setIsSave(true)
		console.log('issave', isSave)
	}

	const changeCheck = e => {
		setUpdateNaz({
			...updateNaz,
			[e.target.name]: e.target.checked
		})
		setIsSave(true)
	}

	const openInput = () => {
		setRefusal(!refusal)
	}

	// const getReports = async id => {
	// 	const a = await http.post('/report/reportApplicationWait?reportType=' + id)
	// 	report.newReport(a.data.reportApplicationWait)
	// }
	// React.useEffect(() => {
	// 	getReports(0)
	// }, [])
	React.useEffect(() => {
		if (openForm) {
			getModaldata()
		}
	}, [])

	const getModaldata = async () => {
		const res = await http.post('/okno/modaldata', {
			uid: student.student.id_student,
			gid: student.student.id_group,
			id_zakaz: student.student.id_okno_zakaz,
			doc: student.student.id_okno_document
		})
		setModalData(res.data.data)
		let arr=res.data.data
		const updatedData = {};

		const keys = [
			'data_c',
			'data_po',
			'data_c_os',
			'data_po_os',
			'data_c_vs',
			'data_po_vs',
			'data_c_practice',
			'data_po_practice',
			'data_c_holidays',
			'data_po_holidays'
		];
	
		keys.forEach(key => {
			if (arr[key] !== null) {
				if (key === 'data_c' || key === 'data_po') {
					updatedData[key] = dayjs(arr[key]).format('YYYY');
				} else {
					updatedData[key] = dayjs(arr[key]).format('YYYY-MM-DD'); 
				}
			} else if (updateData[key]) {
				updatedData[key] = updateData[key];
			}
		});
	
		setUpdateData(prevData => ({
			...prevData,
			...updatedData
		}));
		setUpdateNaz({ naznachenie: res.data.data.naznachenie, surname: res.data.data.surname, practice: res.data.data.practice })
	}

	const updateModalDate = async () => {
		const date_c = dayjs(updateData.data_c).format('YYYY-MM-DD HH:mm:ss')
		// console.log("date_c",date_c)
		const date_po = dayjs(updateData.data_po).format('YYYY-MM-DD HH:mm:ss')
		// console.log("datepo",date_po)
		const date_c_os = dayjs(updateData.data_c_os).format('YYYY-MM-DD HH:mm:ss')
		// console.log("date_c_os",date_c_os)
		const date_po_os = dayjs(updateData.data_po_os).format('YYYY-MM-DD HH:mm:ss')
		// console.log("date_po_os",date_po_os)

		const date_c_vs = dayjs(updateData.data_c_vs).format('YYYY-MM-DD HH:mm:ss')
		// console.log("date_c_vs",date_c_vs)

		const date_po_vs = dayjs(updateData.data_po_vs).format('YYYY-MM-DD HH:mm:ss')
		const date_c_practice = dayjs(updateData.data_c_practice).format('YYYY-MM-DD HH:mm:ss')
		const date_po_practice = dayjs(updateData.data_po_practice).format('YYYY-MM-DD HH:mm:ss')
		const date_c_holidays = dayjs(updateData.data_c_holidays).format('YYYY-MM-DD HH:mm:ss')
		const date_po_holidays = dayjs(updateData.data_po_holidays).format('YYYY-MM-DD HH:mm:ss')

		const res = await http.post('/okno/modalDateUpdate', {
			id_zakaz: student.student.id_okno_zakaz,
			uid: student.student.id_student,
			gid: student.student.id_group,
			doc: student.student.id_okno_document,
			naznachenie: updateNaz.naznachenie,
			surname: updateNaz.surname,
			practice: updateNaz.practice,
			data_c: date_c,
			data_po: date_po,
			data_c_os: date_c_os,
			data_po_os: date_po_os,
			data_c_vs: date_c_vs,
			data_po_vs: date_po_vs,
			data_c_practice: date_c_practice,
			data_po_practice: date_po_practice,
			data_c_holidays: date_c_holidays,
			data_po_holidays: date_po_holidays,
			raion_kg: null,
			work: null,
			cause:null,
			groups: null,
			osnovanii: null,
			order_number: null,
			diploma_series: null,
			// date_of_the_decision_SAC: -1,
			diploma_number: null,
			diploma_reg_number: null,
			qualification: null,
			with_honors: null,
			
			// date_of_issue: -1,
		})
		if (res.data.result !== null) {
			toast(res.data.result)
		}
		setIsSave(false)
		// console.log("update Embass", res);
	}

	const postReasonRefusal = async () => {
		const res = await http.post('/okno/reasonRefusal', {
			id_zakaz: student.student.id_okno_zakaz,
			doc: student.student.id_okno_document,
			rejected_komment: reasonRefusal.rejected_komment
		})
		if (res.data.result == null) {
			toast(res.data.result)
			// getReports(0)
			openForm()
			// setIsSave(false)
		}
		// console.log("update", res);
	}

	React.useEffect(() => {
		document.body.style.overflowY = 'hidden'

		return () => (document.body.style.overflowY = 'visible')
	}, [])

	const onChangeDate = e => {
		setUpdateData({
			...updateData,
			[e.target.name]: e.target.name == 'practice' ? e.target.checked : e.target.value
		})
		setIsSave(true)
	}

	const changeRefusal = e => {
		const { name, value } = e.target
		setReasonRefusal({ ...reasonRefusal, [name]: value })
		console.log(':reasonRefusal', { [name]: value })
	}
	
	return (
		<div className={styles.modal}>
			<div className={styles.modal_window}>
				<div className={styles.modal_window_head}>
					<div></div>
					<label>{modalData.okno_document}</label>
					{!refusal ? (
						<div className={styles.add_form_stud_exit}>
							{updateNaz.naznachenie?.length > 6 ? (
								<a
									className='new_report'
									target='_blank'
									href={`/bt/api/r/embassies?gid=${student.student.id_group}&id=${student.student.id_student}&idf=${student.student.id_faculty}&idr=${student.student.id_raion}&idzakaz=${student.student.id_okno_zakaz}&lang=${i18n.language}`}
								>
									<button className={styles.button_modal} onClick={openForm}>
										Просмотр
									</button>
								</a>
							) : null}
						</div>
					) : (
						<div></div>
					)}
				</div>
				
				{!refusal ? (
					<div>
						<div className={styles.name_student}>
							<div className={styles.name_student_block}>
								<span className={styles.name_student_text}>Студент:</span>
								<p>{modalData?.fio}</p>
							</div>
							<div className={styles.name_student_block}>
								<span className={styles.name_student_text}>Уникальный номер справки:</span>
								<p>{modalData.reference_number}</p>
							</div>
						</div>
						<div className={styles.modal_window_data}>
							<div className={styles.input_block}>
								<span className={styles.name_student_text}>Назначение:</span>
								<input
									className={styles.input_modal}
									type='text'
									name='naznachenie'
									value={updateNaz.naznachenie}
									onChange={change}
								>
									{/* {modalData.naznachenie} */}
								</input>
							</div>
							<div className={styles.input_block}>
								<span className={styles.name_student_text}>Отчество:</span>
								<input
									className={styles.input_modal}
									type='text'
									name='surname'
									value={updateNaz.surname}
									onChange={change}
								>
									{/* {modalData.naznachenie} */}
								</input>
							</div>
							<div className={styles.block_datee}>
								<div className={styles.input_txt}>Период обучения</div>
								<div className={styles.data_block}>
									<div className={styles.input_block_date}>
										<span className={styles.name_student_text}>с:</span>
										<input
											onChange={onChangeDate}
											className={styles.input_modal_date}
											type='number'
											placeholder='YYYY'
											name='data_c'
											value={updateData.data_c}
										/>
									</div>
									<div className={styles.input_block_date}>
										<span className={styles.name_student_text}> по:</span>
										<input
											onChange={onChangeDate}
											className={styles.input_modal_date}
											type='number'
											placeholder='YYYY'
											name='data_po'
											value={updateData.data_po}
										/>
									</div>
								</div>
							</div>
						</div>

						{/* Справка - для посольств */}
						<div className={styles.spravka_posol}>
							<div className={styles.period_txt}>Сроки обучения в текущем учебном году</div>
							<div className={styles.modal_window_date}>
								<div className={styles.block_date}>
									<div className={styles.input_txt}>Осенний семестр</div>
									<div className={styles.data_block}>
										<div className={styles.input_block_date}>
											<span className={styles.name_student_text}>с:</span>
											<input
												onChange={onChangeDate}
												className={styles.input_modal_date}
												type='date'
												name='data_c_os'
												value={updateData.data_c_os}
											/>
										</div>
										<div className={styles.input_block_date}>
											<span className={styles.name_student_text}> по:</span>
											<input
												onChange={onChangeDate}
												className={styles.input_modal_date}
												type='date'
												name='data_po_os'
												value={updateData.data_po_os}
											/>
										</div>
									</div>
								</div>
								<div className={styles.block_date}>
									<div className={styles.input_txt}>Весенний семестр</div>
									<div className={styles.data_block}>
										<div className={styles.input_block_date}>
											<span className={styles.name_student_text}>с:</span>
											<input
												onChange={onChangeDate}
												className={styles.input_modal_date}
												type='date'
												name='data_c_vs'
												value={updateData.data_c_vs}
											/>
										</div>
										<div className={styles.input_block_date}>
											<span className={styles.name_student_text}> по:</span>
											<input
												onChange={onChangeDate}
												className={styles.input_modal_date}
												type='date'
												name='data_po_vs'
												value={updateData.data_po_vs}
											/>
										</div>
									</div>
								</div>
								<div className={styles.block_date}>
									<div className={styles.input_txt_block}>
										<div className={styles.input_txt}>
											<p>Летний семестр</p>
											<p>(практика)</p>
										</div>
										<input
											className={styles.input_modal_check}
											type='checkbox'
											name='practice'
											checked={updateNaz.practice}
											onChange={changeCheck}
										>
											{/* {modalData.naznachenie} */}
										</input>
									</div>
									{updateNaz.practice == true ? (
										<div className={styles.data_block}>
											<div className={styles.input_block_date}>
												<span className={styles.name_student_text}>с:</span>
												<input
													onChange={onChangeDate}
													className={styles.input_modal_date}
													type='date'
													name='data_c_practice'
													value={updateData.data_c_practice}
												/>
											</div>
											<div className={styles.input_block_date}>
												<span className={styles.name_student_text}> по:</span>
												<input
													onChange={onChangeDate}
													className={styles.input_modal_date}
													type='date'
													name='data_po_practice'
													value={updateData.data_po_practice}
												/>
											</div>
										</div>
									) : (
										<div className={styles.data_block}>
											<div className={styles.input_block_date}>
												<span className={styles.name_student_text}>с:</span>
												<input
													onChange={onChangeDate}
													className={styles.input_modal_date}
													type='date'
													name='data_c_practice'
													value={updateData.data_c_practice}
													disabled
												/>
											</div>
											<div className={styles.input_block_date}>
												<span className={styles.name_student_text}> по:</span>
												<input
													onChange={onChangeDate}
													className={styles.input_modal_date}
													type='date'
													name='data_po_practice'
													value={updateData.data_po_practice}
													disabled
												/>
											</div>
										</div>
									)}
								</div>

								<div className={styles.block_date}>
									<div className={styles.input_txt}>Каникул</div>
									<div className={styles.data_block}>
										<div className={styles.input_block_date}>
											<span className={styles.name_student_text}>с:</span>
											<input
												onChange={onChangeDate}
												className={styles.input_modal_date}
												type='date'
												name='data_c_holidays'
												value={updateData.data_c_holidays}
											/>
										</div>
										<div className={styles.input_block_date}>
											<span className={styles.name_student_text}> по:</span>
											<input
												onChange={onChangeDate}
												className={styles.input_modal_date}
												type='date'
												name='data_po_holidays'
												value={updateData.data_po_holidays}
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className={styles.user}>
							<div className={styles.user_name}>
								<span className={styles.name_student_text}>Исполнитель:</span>
								<p>{modalData.AVN_operator}</p>
							</div>
						</div>
					</div>
				) : (
					<div className={styles.modal_window_data}>
						<div className={styles.input_block}>
							<span className={styles.name_student_text}>Причина отказа:</span>
							<input
								className={styles.input_modal}
								type='text'
								placeholder='Введите причину отказа...'
								name='rejected_komment'
								value={reasonRefusal.rejected_komment}
								onChange={changeRefusal}
							>
								{/* Причина отказа */}
							</input>
						</div>
					</div>
				)}

				<div className={styles.modal_footer}>
					<div></div>
					<div className={styles.footer_buttons}>
						{refusal ? (
							<>
								{reasonRefusal.rejected_komment?.length >= 6 ? (
									<button onClick={postReasonRefusal} className={styles.button_modal}>
										Отказать
									</button>
								) : (
									<button
										className={styles.button_modal}
										style={{ background: '#c8c8c8' }}
										disabled
										onClick={postReasonRefusal}
									>
										Отказать
									</button>
								)}
								<button onClick={openInput} className={styles.button_modal}>
									Назад
								</button>
							</>
						) : (
							<>
								<button onClick={openInput} className={styles.button_modal}>
									Отказать
								</button>
								{updateNaz.naznachenie?.length >= 3 && isSave ? (
									<button className={styles.button_modal} onClick={updateModalDate}>
										Сохранить
									</button>
								) : (
									<button
										className={styles.button_modal}
										style={{ background: '#c8c8c8' }}
										disabled
										onClick={updateModalDate}
									>
										Сохранить
									</button>
								)}
								<button onClick={openForm} className={styles.button_modal}>
									Закрыть
								</button>
							</>
						)}
					</div>
				</div>
			</div>
		</div>
	)
}

export default EmbassiesModal
